exitApp = function () {
  api.addEventListener({
    name: 'keyback'
  }, function (ret, err) {
    api.toast({
      msg: '再次点击返回键退出APP',
      duration: 2000,
      location: 'bottom'
    });

    api.addEventListener({
      name: 'keyback'
    }, function (ret, err) {
      api.closeWidget({
        id: 'A6122368097326',
        silent: true
      });
    });
    setTimeout(function () {
      exitApp();
    }, 3000)
  })
}


// WEBPACK FOOTER //
// ./src/assets/js/exitApp.js